import classNames from "classnames/bind";
import style from "./ConfigStream.module.css";
import { Button, Col, Loading, Row, Toast } from "../../../../components";
import ListConfig from "../ListConfig";
import { useState } from "react";
import { useEffect } from "react";
import { listInfoPlaybackConfig, listInfoStreamConfig } from "../config";
import { configDefault } from "../../../../services/api/configDefault";
import ModalConfirm from "../ModalConfirm";

const cx = classNames.bind(style);

function ConfigStream({ label, codeService, config, handleRefresh }) {
    const [loading, setLoading] = useState(false);
    const [paramConfig, setParamConfig] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [token, setToken] = useState('');
    const handleAddValue = (key, value) => {
        const param = paramConfig.map((item) => {
            if (item.id === key) {
                return {
                    ...item,
                    value: value,
                }
            } else {
                return item
            }
        })
        setParamConfig(param)
    }
    const onChangeParam = (key, value) => {
        if (key === 'time_save') {
            if (Number(value) > 14 || Number(value) <= 0) {
                Toast.open('Số ngày lưu tối đa là 14 ngày, tối thiểu là 1 ngày', "danger")
            } else {
                handleAddValue(key, value)
            }
        } else {
            handleAddValue(key, value)
        }

    }

    const getDefaultConfig = (config, params) => {
        const valueParam = params.map((item) => {
            const value = config?.find((it) => it.KEY.toLocaleLowerCase() === item.id);
            if (value) {
                return {
                    ...item,
                    code: value.CODE,
                    value: value.VALUE
                }
            } else {
                return item
            }
        })
        setParamConfig(valueParam)
    }

    useEffect(() => {
        if (codeService === 'xtt') {
            getDefaultConfig(config, listInfoStreamConfig)
        } else {
            getDefaultConfig(config, listInfoPlaybackConfig)
        }
    }, [codeService, config])

    // lưu tất cả và lưu cho cam mới đang để giống nhau

    const handleApplyAll = async () => {
        setLoading(true)
        try {
            let formData = [];
            paramConfig.forEach(item => {
                const param = {
                    key: item.id.toUpperCase() || "",
                    code: item.code || 2,
                    value: item.value || "",
                }
                formData.push(param)
            })
            const res = await configDefault.putChangeSystemDefaultConfig(formData, 'all_cam');
            setLoading(false)
            if (codeService !== 'xtt' && res.token.length > 0) {
                setShowModal(res.result)
                setToken(res.token)
            } else {
                Toast.open("Lưu cài đặt thành công", "success")
            }
        } catch (error) {
            setLoading(false)
            Toast.open("Lưu cài đặt không thành công", "danger")
        }
    }
    const handleAppForNewCam = async () => {
        setLoading(true)
        try {
            let formData = [];
            paramConfig.forEach(item => {
                const param = {
                    key: item.id.toUpperCase() || "",
                    code: item.code || 2,
                    value: item.value || "",
                }
                formData.push(param)
            })
            setLoading(false)
            const res = await configDefault.putChangeSystemDefaultConfig(formData)
            if (codeService !== 'xtt' && res.token.length > 0) {
                setShowModal(res.result)
                setToken(res.token)
            } else {
                Toast.open("Lưu cài đặt thành công", "success")
            }
        } catch (error) {
            setLoading(false)
            Toast.open("Lưu cài đặt không thành công", "danger")
        }
    }

    const handleCancel = () => {
        handleRefresh()
    }
    return (
        <>
            {loading && <div className={cx('modal-load')}>
                <Loading />
            </div>}
            <Row gap={[0, 16]}>
                <Col span={12}>
                    <ListConfig listParamConfig={paramConfig} onChangeParam={onChangeParam} />
                </Col>
            </Row>
            <Row gap={[0, 16]}>
                <Col span={12}>
                    <div className={cx('footer')}>
                        <Button title={'Hủy bỏ'} className={cx('btn', 'cancel')} onClick={handleCancel} />
                        <Button title={'Áp dụng tất cả'} className={cx('btn')} onClick={handleApplyAll} />
                        <Button title={'Áp dụng mới'} className={cx('btn')} onClick={handleAppForNewCam} />
                    </div>
                </Col>
            </Row>
            <ModalConfirm isShow={showModal} onClose={() => setShowModal(false)} token={token} />
        </>
    )
}


export default ConfigStream;